<div class="modal-container">
  <div class="modal-header">
    <div class="modal-header-title">{{options.title}}</div>
    <div class="modal-header-full" *ngIf="options.showFullscreen??false">
      <span class="fa-solid fa-expand" (click)="openfullscreen()" *ngIf="!isFullScreen"></span>
      <span class="fa-solid fa-compress" (click)="closefullscreen()" *ngIf="isFullScreen"></span>
    </div>
    <div class="modal-header-close" *ngIf="options.showCross??true" (click)="onCancel('Cross click')"><span class="far fa-times"></span></div>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer" *ngIf="(options.showSave??true)||(options.showCancel??true)">
    <button class="btn btn-primary" *ngIf="options.showSave??true" (click)="onSave()" [disabled]="!isValid">{{options.saveText??'Save'}}</button>
    <button class="btn btn-primary2" *ngIf="options.showCancel??true" ngbAutofocus (click)="onCancel('Cancel Clicked')">{{options.cancelText??'Cancel'}}</button>
  </div>
</div>
